// Ejemplo de data (aquí solo muestro un departamento, una provincia y un distrito para simplificar)
const data = {
  'Amazonas': {
    'Chachapoyas': ['Chachapoyas', 'Asunción', 'Balsas', 'Cheto', 'Chiliquin', 'Chuquibamba', 'Granada', 'Huancas', 'La Jalca', 'Leimebamba', 'Levanto', 'Magdalena', 'Mariscal Castilla', 'Molinopampa', 'Montevideo', 'Olleros', 'Quinjalca', 'San Francisco de Daguas', 'San Isidro de Maino', 'Soloco', 'Sonche'],
    'Bagua': ['Bagua', 'Aramango', 'Copallin', 'El Parco', 'Imaza', 'La Peca'],
    'Bongará': ['Jumbilla', 'Chisquilla', 'Churuja', 'Corosha', 'Cuispes', 'Florida', 'Jazan', 'Recta', 'San Carlos', 'Shipasbamba', 'Valera', 'Yambrasbamba'],
    'Condorcanqui': ['Nieva', 'El Cenepa', 'Rio Santiago'],
    'Luya': ['Lamud', 'Camporredondo', 'Cocabamba', 'Conila', 'Inguilpata', 'Longuita', 'Lonya Chico', 'Luya', 'Luya Viejo', 'Maria', 'Ocalli', 'Ocumal', 'Pisuquia', 'Providencia', 'San Cristobal', 'San Francisco del Yeso', 'San Jeronimo', 'San Juan de Lopecancha', 'Santa Catalina', 'Santo Tomas', 'Tingo', 'Trita'],
    'Rodríguez de Mendoza': ['San Nicolás', 'Chirimoto', 'Cochamal', 'Huambo', 'Limabamba', 'Longar', 'Mariscal Benavides', 'Milpuc', 'Omia', 'Santa Rosa', 'Totora', 'Vista Alegre'],
    'Utcubamba': ['Bagua Grande', 'Cajaruro', 'Cumba', 'El Milagro', 'Jamalca', 'Lonya Grande', 'Yamon']
  },

  'Ancash': {
    'Huaraz': ['Huaraz', 'Cochabamba', 'Colcabamba', 'Huanchay', 'Independencia', 'Jangas', 'La Libertad', 'Olleros', 'Pampas', 'Pariacoto', 'Pira', 'Tarica'],
    'Aija': ['Aija', 'Coris', 'Huacllan', 'La Merced', 'Succha'],
    'Antonio Raymondi': ['Llamellin', 'Aczo', 'Chaccho', 'Chingas', 'Mirgas', 'San Juan de Rontoy'],
    'Asunción': ['Chacas', 'Acochaca'],
    'Bolognesi': ['Chiquian', 'Abelardo Pardo Lezameta', 'Antonio Raymondi', 'Aquia', 'Cajacay', 'Canis', 'Colquioc', 'Huallanca', 'Huasta', 'Huayllacayan', 'La Primavera', 'Mangas', 'Pacos', 'San Miguel de Corpanqui', 'Ticllos'],
    'Carhuaz': ['Carhuaz', 'Acopampa', 'Amashca', 'Anta', 'Ataquero', 'Marcara', 'Pariahuanca', 'San Miguel de Aco', 'Shilla', 'Tinco', 'Yungar'],
    'Carlos Fermín Fitzcarrald': ['San Luis', 'San Nicolás', 'Yauya'],
    'Casma': ['Casma', 'Buena Vista Alta', 'Comandante Noel', 'Yautan'],
    'Corongo': ['Corongo', 'Aco', 'Bambas', 'Cusca', 'La Pampa', 'Yanac', 'Yupan'],
    'Huari': ['Huari', 'Anra', 'Cajay', 'Chavin de Huantar', 'Huacachi', 'Huacchis', 'Huachis', 'Huantar', 'Masin', 'Paucas', 'Ponto', 'Rahuapampa', 'Rapayan', 'San Marcos', 'San Pedro de Chana', 'Uco'],
    'Huarmey': ['Huarmey', 'Cochapeti', 'Culebras', 'Huayan', 'Malvas'],
    'Huaylas': ['Caraz', 'Huallanca', 'Huata', 'Huayan', 'Mato', 'Pamparomas', 'Pueblo Libre', 'Santa Cruz', 'Santo Toribio', 'Yuracmarca'],
    'Mariscal Luzuriaga': ['Piscobamba', 'Casca', 'Eleazar Guzmán Barron', 'Fidel Olivas Escudero', 'Llama', 'Llumpa', 'Lucma', 'Musga', 'Santa Anta', 'Tauca'],
    'Ocros': ['Ocros', 'Acas', 'Cajamarquilla', 'Carhuapampa', 'Cochas', 'Congas', 'Llipa', 'San Cristóbal de Rajan', 'San Pedro', 'Santiago de Chilcas'],
    'Pallasca': ['Cabana', 'Bolognesi', 'Conchucos', 'Huacaschuque', 'Huandoval', 'Lacabamba', 'Llapo', 'Pallasca', 'Pampas', 'Santa Rosa', 'Tauca'],
    'Pomabamba': ['Pomabamba', 'Huayllan', 'Parobamba', 'Quinuabamba'],
    'Recuay': ['Recuay', 'Catac', 'Cotaparaco', 'Huayllapampa', 'Llacllin', 'Marca', 'Pampas Chico', 'Pararin', 'Tapacocha', 'Ticapampa'],
    'Santa': ['Chimbote', 'Cáceres del Perú', 'Coishco', 'Macate', 'Moro', 'Nepeña', 'Samanco', 'Santa', 'Nuevo Chimbote'],
    'Sihuas': ['Sihuas', 'Alfonso Ugarte', 'Cashapampa', 'Chingalpo', 'Huayllabamba', 'Quiches', 'Ragash', 'San Juan', 'Sicsibamba'],
    'Yungay': ['Yungay', 'Cascapara', 'Mancos', 'Matacoto', 'Quillo', 'Ranrahirca', 'Shupluy', 'Yanama']
  },

  'Apurímac': {
    'Abancay': ['Abancay', 'Chacoche', 'Circa', 'Curahuasi', 'Huanipaca', 'Lambrama', 'Pichirhua', 'San Pedro de Cachora', 'Tamburco'],
    'Andahuaylas': ['Andahuaylas', 'Andarapa', 'Chiara', 'Huancarama', 'Huancaray', 'Huayana', 'Kishuara', 'Pacobamba', 'Pacucha', 'Pampachiri', 'Pomacocha', 'San Antonio de Cachi', 'San Jeronimo', 'San Miguel de Chaccrampa', 'Santa Maria de Chicmo', 'Talavera', 'Tumay Huaraca', 'Turpo', 'Kaquiabamba', 'Jose Maria Arguedas'],
    'Antabamba': ['Antabamba', 'El Oro', 'Huaquirca', 'Juan Espinoza Medrano', 'Oropesa', 'Pachaconas', 'Sabaino'],
    'Aymaraes': ['Chalhuanca', 'Capaya', 'Caraybamba', 'Chapimarca', 'Colcabamba', 'Cotaruse', 'Ihuayllo', 'Justo Apu Sahuaraura', 'Lucre', 'Pocohuanca', 'San Juan de Chacña', 'San Raymundo', 'Soras'],
    'Cotabambas': ['Tambobamba', 'Cotabambas', 'Coyllurqui', 'Haquira', 'Mara', 'Challhuahuacho'],
    'Chincheros': ['Chincheros', 'Anco_Huallo', 'Cocharcas', 'Huaccana', 'Ocobamba', 'Ongoy', 'Uranmarca', 'Ranracancha', 'Rocchacc', 'El Porvenir', 'Los Chankas'],
    'Grau': ['Chuquibambilla', 'Curpahuasi', 'Gamarra', 'Huayllati', 'Mamara', 'Micaela Bastidas', 'Pataypampa', 'Progreso', 'San Antonio', 'Santa Rosa', 'Turpay', 'Vilcabamba', 'Virundo', 'Curasco'],
},

  'Arequipa': {
    'Arequipa': ['Arequipa', 'Alto Selva Alegre', 'Cayma', 'Cerro Colorado', 'Characato', 'Chiguata', 'Jacobo Hunter', 'La Joya', 'Mariano Melgar', 'Miraflores', 'Mollebaya', 'Paucarpata', 'Pocsi', 'Polobaya', 'Quequeña', 'Sabandia', 'Sachaca', 'San Juan de Siguas', 'San Juan de Tarucani', 'Santa Isabel de Siguas', 'Santa Rita de Siguas', 'Socabaya', 'Tiabaya', 'Vitor', 'Yanahuara', 'Yarabamba', 'Yura'],
    'Camana': ['Camana', 'Jose Maria Quimper', 'Mariano Nicolas Valcarcel', 'Mariscal Caceres', 'Nicolas de Pierola', 'Ocoña', 'Quilca', 'Samuel Pastor'],
    'Caravelí': ['Caravelí', 'Acarí', 'Atico', 'Atiquipa', 'Bella Unión', 'Cahuacho', 'Chala', 'Chaparra', 'Huanuhuanu', 'Jaqui', 'Lomas', 'Quicacha', 'Yauca'],
    'Castilla': ['Aplao', 'Andagua', 'Ayo', 'Chachas', 'Chilcaymarca', 'Choco', 'Huancarqui', 'Machaguay', 'Orcopampa', 'Pampacolca', 'Tipan'],
    'Caylloma': ['Chivay', 'Achoma', 'Cabanaconde', 'Callalli', 'Caylloma', 'Coporaque', 'Huambo', 'Huanca', 'Ichupampa', 'Lari', 'Lluta', 'Maca', 'Madrigal', 'San Antonio de Chuca', 'Sibayo', 'Tapay', 'Tisco', 'Tuti', 'Yanque'],
    'Condesuyos': ['Chuquibamba', 'Andaray', 'Cayarani', 'Chichas', 'Iray', 'Río Grande', 'Salamanca', 'Yanaquihua'],
    'Islay': ['Mollendo', 'Cocachacra', 'Dean Valdivia', 'Islay', 'Mejía', 'Punta de Bombón'],
    'La Uniòn': ['Cotahuasi', 'Alca', 'Charcana', 'Huaynacotas', 'Pampamarca', 'Puyca', 'Quechualla', 'Sayla', 'Tauría', 'Tomepampa', 'Toro']
  },

  'Ayacucho': {
    'Huamanga': ['Ayacucho', 'Acocro', 'Acos Vinchos', 'Carmen Alto', 'Chiara', 'Ocros', 'Pacaycasa', 'Quinua', 'San Jose de Ticllas', 'San Juan Bautista', 'Santiago de Pischa', 'Socos', 'Tambillo', 'Vinchos', 'Jesús Nazareno', 'Andres Avelino Caceres Dorregaray'],
    'Cangallo': ['Cangallo', 'Chuschi', 'Los Morochucos', 'Maria Parado de Bellido', 'Paras', 'Totos'],
    'Huanca Sancos': ['Sancos', 'Carapo', 'Sacsamarca', 'Santiago de Lucanamarca'],
    'Huanta': ['Huanta', 'Ayahuanco', 'Huamanguilla', 'Iguain', 'Luricocha', 'Santillana', 'Sivia', 'Llochegua', 'Canayre'],
    'La Mar': ['San Miguel', 'Anco', 'Ayna', 'Chilcas', 'Chungui', 'Luis Carranza', 'San Pedro de Cachora', 'Tambo'],
    'Lucanas': ['Puquio', 'Aucara', 'Cabana', 'Carmen Salcedo', 'Chaviña', 'Chipao', 'Huac-Huas', 'Laramate', 'Leoncio Prado', 'Llauta', 'Lucanas', 'Ocaña', 'Otoca', 'Saisa', 'San Cristobal', 'San Juan', 'San Pedro', 'San Pedro de Palco', 'Sancos', 'Santa Ana de Huaycahuacho', 'Santa Lucia'],
    'Parinacochas': ['Coracora', 'Chumpi', 'Coronel Castañeda', 'Pacapausa', 'Pullo', 'Puyusca', 'San Francisco de Ravacayco', 'Upahuacho'],
    'Paucar del Sara Sara': ['Pausa', 'Colta', 'Corculla', 'Lampa', 'Marcabamba', 'Oyolo', 'Pararca', 'San Javier de Alpabamba', 'San Jose de Ushua', 'Sara Sara'],
    'Sucre': ['Querobamba', 'Belen', 'Chalcos', 'Chilcayoc', 'Huacaña', 'Morcolla', 'Paico', 'San Pedro de Larcay', 'San Salvador de Quije', 'Santiago de Paucaray'],
    'Victor Fajardo': ['Huancapi', 'Alcamenca', 'Apongo', 'Asquipata', 'Canaria', 'Cayara', 'Colca', 'Huamanquiquia', 'Huancaraylla', 'Huaya', 'Sarhua', 'Vilcanchos'],
    'Vilcas Huaman': ['Vilcas Huaman', 'Accomarca', 'Carhuanca', 'Concepcion', 'Huambalpa', 'Independencia', 'Saurama', 'Vischongo'],
  },

  'Cajamarca': {
    'Cajamarca': ['Cajamarca', 'Asunción', 'Chetilla', 'Cospan', 'Encañada', 'Jesús', 'Llacanora', 'Los Baños del Inca', 'Magdalena', 'Matara', 'Namora', 'San Juan'],
    'Cajabamba': ['Cajabamba', 'Cachachi', 'Condebamba', 'Sitacocha'],
    'Celendín': ['Celendín', 'Chumuch', 'Cortegana', 'Huasmin', 'Jorge Chavez', 'José Gálvez', 'La Libertad de Pallán', 'Miguel Iglesias', 'Oxamarca', 'Sorochuco', 'Sucre', 'Utco'],
    'Chota': ['Chota', 'Anguia', 'Chadin', 'Chiguirip', 'Chimban', 'Choropampa', 'Cochabamba', 'Conchan', 'Huambos', 'Lajas', 'Llama', 'Miracosta', 'Paccha', 'Pion', 'Querocoto', 'San Juan de Licupis', 'Tacabamba', 'Tocmoche'],
    'Contumazá': ['Contumazá', 'Chilete', 'Cupisnique', 'Guzmango', 'San Benito', 'Santa Cruz de Toledo', 'Tantarica', 'Yonán'],
    'Cutervo': ['Cutervo', 'Callayuc', 'Choros', 'Cujillo', 'La Ramada', 'Pimpingos', 'Querocotillo', 'San Andrés de Cutervo', 'San Juan de Cutervo', 'San Luis de Lucma', 'Santa Cruz', 'Santo Domingo de la Capilla', 'Santo Tomás', 'Socota', 'Toribio Casanova'],
    'Hualgayoc': ['Bambamarca', 'Chugur', 'Hualgayoc'],
    'Jaén': ['Jaén', 'Bellavista', 'Chontali', 'Colasay', 'Huabal', 'Las Pirias', 'Pomahuaca', 'Pucará', 'Sallique', 'San Felipe', 'San José del Alto', 'Santa Rosa'],
    'San Ignacio': ['San Ignacio', 'Chirinos', 'Huarango', 'La Coipa', 'Namballe', 'San José de Lourdes', 'Tabaconas'],
    'San Marcos': ['San Marcos', 'Chancay', 'Eduardo Villanueva', 'Gregorio Pita', 'Ichoca', 'José Manuel Quiroz', 'José Sabogal', 'Pedro Gálvez'],
    'San Miguel': ['San Miguel', 'Bolívar', 'Calquis', 'Catilluc', 'El Prado', 'La Florida', 'Llapa', 'Nanchoc', 'Niepos', 'San Gregorio', 'San Silvestre de Cochan', 'Tongod', 'Unión Agua Blanca'],
    'San Pablo': ['San Pablo', 'San Bernardino', 'San Luis', 'Tumbaden'],
    'Santa Cruz': ['Santa Cruz', 'Andabamba', 'Catache', 'Chancaybaños', 'La Esperanza', 'Ninabamba', 'Pulan', 'Saucepampa', 'Sexi', 'Uticyacu', 'Yauyucan']
  },

  'Callao': {
    'Callao': ['Bellavista', 'Callao', 'Carmen de la Legua Reynoso', 'La Perla', 'La Punta', 'Ventanilla', 'Mi Perú'],
  },

  'Cusco': {
    'Cusco': ['Cusco', 'Ccorca', 'Poroy', 'San Jerónimo', 'San Sebastián', 'Santiago', 'Saylla', 'Wanchaq'],
    'Acomayo': ['Acomayo', 'Acopia', 'Acos', 'Mosoc Llacta', 'Pomacanchi', 'Rondocan', 'Sangarará'],
    'Anta': ['Anta', 'Ancahuasi', 'Cachimayo', 'Chinchaypujio', 'Huarocondo', 'Limatambo', 'Mollepata', 'Pucyura', 'Zurite'],
    'Calca': ['Calca', 'Coya', 'Lamay', 'Lares', 'Pisac', 'San Salvador', 'Taray', 'Yanatile'],
    'Canas': ['Yanaoca', 'Checca', 'Kunturkanki', 'Langui', 'Layo', 'Pampamarca', 'Quehue', 'Tupac Amaru'],
    'Canchis': ['Sicuani', 'Checacupe', 'Combapata', 'Marangani', 'Pitumarca', 'San Pablo', 'San Pedro', 'Tinta'],
    'Chumbivilcas': ['Santo Tomás', 'Capacmarca', 'Chamaca', 'Colquemarca', 'Livitaca', 'Llusco', 'Quiñota', 'Velille'],
    'Espinar': ['Espinar', 'Condoroma', 'Coporaque', 'Ocoruro', 'Pallpata', 'Pichigua', 'Suyckutambo', 'Alto Pichigua'],
    'La Convención': ['Santa Ana', 'Echarate', 'Huayopata', 'Maranura', 'Ocobamba', 'Quellouno', 'Kimbiri', 'Santa Teresa', 'Vilcabamba', 'Pichari', 'Inkawasi', 'Villa Virgen', 'Villa Kintiarina', 'Megantoni'],
    'Paruro': ['Paruro', 'Accha', 'Ccapi', 'Colcha', 'Huanoquite', 'Omacha', 'Paccaritambo', 'Pillpinto', 'San Salvador', 'Caicay', 'Yaurisque'],
    'Paucartambo': ['Paucartambo', 'Caicay', 'Challabamba', 'Colquepata', 'Kosñipata', 'Huancarani'],
    'Quispicanchi': ['Urcos', 'Andahuaylillas', 'Camanti', 'Ccarhuayo', 'Ccatca', 'Cusipata', 'Huaro', 'Lucre', 'Marcapata', 'Ocongate', 'Oropesa', 'Quiquijana'],
    'Urubamba': ['Urubamba', 'Chinchero', 'Huayllabamba', 'Machupicchu', 'Maras', 'Ollantaytambo', 'Yucay']
  },

  'Huancavelica': {
    'Huancavelica': ['Huancavelica', 'Acobambilla', 'Acoria', 'Conayca', 'Cuenca', 'Huachocolpa', 'Huayllahuara', 'Izcuchaca', 'Laria', 'Manta', 'Mariscal Cáceres', 'Moya', 'Nuevo Occoro', 'Palca', 'Pilchaca', 'Vilca', 'Yauli', 'Ascensión'],
    'Acobamba': ['Acobamba', 'Andabamba', 'Anta', 'Caja', 'Marcas', 'Paucará', 'Pomacocha', 'Rosario'],
    'Angaraes': ['Lircay', 'Anchonga', 'Callanmarca', 'Ccochaccasa', 'Chincho', 'Congalla', 'Huanca-Huanca', 'Huayllay Grande', 'Julcamarca', 'San Antonio de Antaparco', 'Santo Tomás de Pata', 'Secclla', 'Oropesa'],
    'Castrovirreyna': ['Castrovirreyna', 'Arma', 'Aurahuá', 'Capillas', 'Chupamarca', 'Cocas', 'Huachos', 'Huamatambo', 'Mollepampa', 'San Juan', 'Santa Ana', 'Tantara', 'Ticrapo'],
    'Churcampa': ['Churcampa', 'Anco', 'Chinchihuasi', 'Cosme', 'El Carmen', 'La Merced', 'Locroja', 'Paucarbamba', 'San Miguel de Mayocc', 'San Pedro de Coris'],
    'Huaytará': ['Huaytará', 'Ayaví', 'Córdova', 'Huayacundo Arma', 'Laramarca', 'Ocoyo', 'Pilpichaca', 'Querco', 'Quito-Arma', 'San Antonio de Cusicancha', 'San Francisco de Sangayaico', 'San Isidro', 'Santiago de Chocorvos', 'Santiago de Quirahuara', 'Santo Domingo de Capillas', 'Tambo'],
    'Tayacaja': ['Pampas', 'Acostambo', 'Acraquia', 'Ahuaycha', 'Colcabamba', 'Daniel Hernández', 'Huachocolpa', 'Huaribamba', 'Ñahuimpuquio', 'Pazos', 'Quishuar', 'Salcabamba', 'Salcahuasi', 'San Marcos de Rocchac', 'Surcubamba', 'Tintay Puncu', 'Quichuas']
  },

  'Huánuco': {
    'Huánuco': ['Huánuco', 'Amarilis', 'Chinchao', 'Churubamba', 'Margos', 'Quisqui (Kichki)', 'San Francisco de Cayrán', 'San Pedro de Chaulán', 'Santa María del Valle', 'Yarumayo', 'Pillco Marca'],
    'Ambo': ['Ambo', 'Cayna', 'Colpas', 'Conchamarca', 'Huácar', 'San Francisco', 'San Rafael', 'Tomay-Kichwa'],
    'Dos de Mayo': ['La Unión', 'Chuquis', 'Marías', 'Pachas', 'Quivilla', 'Ripán', 'Shunqui', 'Sillapata', 'Yanas'],
    'Huacaybamba': ['Huacaybamba', 'Canchabamba', 'Cochabamba', 'Pinra'],
    'Huamalíes': ['Llata', 'Arancay', 'Chavín de Pariarca', 'Jacas Grande', 'Jircan', 'Miraflores', 'Monzón', 'Punchao', 'Puños', 'Singa', 'Tantamayo'],
    'Leoncio Prado': ['Rupa-Rupa', 'Daniel Alomía Robles', 'Hermílio Valdizán', 'José Crespo y Castillo', 'Luyando', 'Mariano Damaso Beraún', 'Pucayacu'],
    'Marañón': ['Huacrachuco', 'Cholón', 'San Buenaventura'],
    'Pachitea': ['Panao', 'Chaglla', 'Molino', 'Umari'],
    'Puerto Inca': ['Puerto Inca', 'Codo del Pozuzo', 'Honoria', 'Tournavista', 'Yuyapichis'],
    'Lauricocha': ['Jesús', 'Baños', 'Jivia', 'Queropalca', 'Rondos', 'San Francisco de Asís', 'San Miguel de Cauri'],
    'Yarowilca': ['Chavinillo', 'Cahuac', 'Chacabamba', 'Chupán', 'Jacas Chico', 'Obas', 'Pampamarca', 'Choras']
  },

  'Ica': {
    'Ica': ['Ica', 'La Tinguiña', 'Los Aquijes', 'Ocucaje', 'Pachacutec', 'Parcona', 'Pueblo Nuevo', 'Salas', 'San José de Los Molinos', 'San Juan Bautista', 'Santiago', 'Subtanjalla', 'Tate', 'Yauca del Rosario'],
    'Chincha': ['Chincha Alta', 'Alto Laran', 'Chavín', 'Chincha Baja', 'El Carmen', 'Grocio Prado', 'Pueblo Nuevo', 'San Juan de Yanac', 'San Pedro de Huacarpana', 'Sunampe', 'Tambo de Mora'],
    'Nazca': ['Nazca', 'Changuillo', 'El Ingenio', 'Marcona', 'Vista Alegre'],
    'Palpa': ['Palpa', 'Llipata', 'Río Grande', 'Santa Cruz', 'Tibillo'],
    'Pisco': ['Pisco', 'Huancano', 'Humay', 'Independencia', 'Paracas', 'San Andrés', 'San Clemente', 'Tupac Amaru Inca']
  },

  'Junín': {
    'Huancayo': ['Huancayo', 'Carhuacallanga', 'Chacapampa', 'Chicche', 'Chilca', 'Chongos Alto', 'Chupuro', 'Colca', 'Cullhuas', 'El Tambo', 'Huacrapuquio', 'Hualhuas', 'Huancan', 'Huasicancha', 'Huayucachi', 'Ingenio', 'Pariahuanca', 'Pilcomayo', 'Pucara', 'Quichuay', 'Quilcas', 'San Agustín', 'San Jerónimo de Tunan', 'Saño', 'Sapallanga', 'Sicaya', 'Santo Domingo de Acobamba', 'Viques'],
    'Concepción': ['Concepción', 'Aco', 'Andamarca', 'Chambara', 'Cochas', 'Comas', 'Heroínas Toledo', 'Manzanares', 'Mariscal Castilla', 'Matahuasi', 'Mito', 'Nueve de Julio', 'Orcotuna', 'San José de Quero', 'Santa Rosa de Ocopa'],
    'Chanchamayo': ['La Merced', 'Perené', 'Pichanaqui', 'San Luis de Shuaro', 'San Ramón', 'Vitoc'],
    'Jauja': ['Jauja', 'Acolla', 'Apata', 'Ataura', 'Canchayllo', 'Curicaca', 'El Mantaro', 'Huamali', 'Huaripampa', 'Huertas', 'Huipara', 'Janjaillo', 'Julcán', 'Leonor Ordóñez', 'Llocllapampa', 'Marco', 'Masma', 'Masma Chicche', 'Molinos', 'Monobamba', 'Muqui', 'Muquiyauyo', 'Paca', 'Paccha', 'Pancan', 'Parco', 'Pomacancha', 'Ricran', 'San Lorenzo', 'San Pedro de Chunan', 'Sausa', 'Sincos', 'Tunan Marca', 'Yauli', 'Yauyos'],
    'Junín': ['Junín', 'Carhuamayo', 'Ondores', 'Ulcumayo'],
    'Satipo': ['Satipo', 'Coviriali', 'Llaylla', 'Mazamari', 'Pampa Hermosa', 'Pangoa', 'Río Negro', 'Río Tambo', 'Vizcatán del Ene'],
    'Tarma': ['Tarma', 'Acobamba', 'Huaricolca', 'Huasahuasi', 'La Unión', 'Palca', 'Palcamayo', 'San Pedro de Cajas', 'Tapo'],
    'Yauli': ['La Oroya', 'Chacapalpa', 'Huay-Huay', 'Marcapomacocha', 'Morococha', 'Paccha', 'Santa Bárbara de Carhuacayan', 'Santa Rosa de Sacco', 'Suitucancha', 'Yauli'],
    'Chupaca': ['Chupaca', 'Ahuac', 'Chongos Bajo', 'Huachac', 'Huamancaca Chico', 'San Juan de Iscos', 'San Juan de Jarpa', 'Tres de Diciembre', 'Yanacancha']
  },

  'La Libertad': {
    'Trujillo': ['Trujillo', 'El Porvenir', 'Florencia de Mora', 'Huanchaco', 'La Esperanza', 'Laredo', 'Moche', 'Poroto', 'Salaverry', 'Simbal', 'Victor Larco Herrera'],
    'Ascope': ['Ascope', 'Casa Grande', 'Chicama', 'Chocope', 'Magdalena de Cao', 'Paiján', 'Rázuri', 'Santiago de Cao', 'Buenos Aires'],
    'Bolívar': ['Bolívar', 'Bambamarca', 'Condormarca', 'Longotea', 'Uchumarca', 'Ucuncha'],
    'Chepén': ['Chepén', 'Pacanga', 'Pueblo Nuevo'],
    'Julcán': ['Julcán', 'Calamarca', 'Carabamba', 'Huaso'],
    'Otuzco': ['Otuzco', 'Agallpampa', 'Charat', 'Huaranchal', 'La Cuesta', 'Mache', 'Paranday', 'Salpo', 'Sinsicap', 'Usquil'],
    'Pacasmayo': ['San Pedro de Lloc', 'Guadalupe', 'Jequetepeque', 'Pacasmayo', 'San José'],
    'Pataz': ['Tayabamba', 'Buldibuyo', 'Chillia', 'Huancaspata', 'Huaylillas', 'Huayo', 'Ongón', 'Parcoy', 'Pataz', 'Pias', 'Santiago de Challas', 'Taurija', 'Urpay'],
    'Sánchez Carrión': ['Huamachuco', 'Chugay', 'Cochorco', 'Curgos', 'Marcabal', 'Sanagorán', 'Sarin', 'Sartimbamba'],
    'Santiago de Chuco': ['Santiago de Chuco', 'Angasmarca', 'Cachicadán', 'Mollebamba', 'Mollepata', 'Quiruvilca', 'Santa Cruz de Chuca', 'Santo Domingo de Anda'],
    'Gran Chimú': ['Cascas', 'Lucma', 'Marmot', 'Sayapullo'],
    'Virú': ['Virú', 'Chao', 'Guadalupito']
  },

  'Lambayeque': {
    'Chiclayo': ['Chiclayo', 'Chongoyape', 'Eten', 'Eten Puerto', 'José Leonardo Ortiz', 'La Victoria', 'Lagunas', 'Monsefú', 'Nueva Arica', 'Oyotún', 'Picsi', 'Pimentel', 'Reque', 'Santa Rosa', 'Saña', 'Cayaltí', 'Pátapo', 'Pomalca', 'Pucalá', 'Tumán'],
    'Ferreñafe': ['Ferreñafe', 'Cañaris', 'Incahuasi', 'Manuel Antonio Mesones Muro', 'Pitipo', 'Pueblo Nuevo'],
    'Lambayeque': ['Lambayeque', 'Chochope', 'Illimo', 'Jayanca', 'Mochumí', 'Mórrope', 'Motupe', 'Olmos', 'Pacora', 'Salas', 'San José', 'Túcume']
  },

  'Lima (Departamento)': {
    'Barranca': ['Barranca', 'Paramonga', 'Pativilca', 'Supe', 'Supe Puerto'],
    'Cajatambo': ['Cajatambo', 'Copa', 'Gorgor', 'Huancapon', 'Manas'],
    'Canta': ['Canta', 'Arahuay', 'Huamantanga', 'Huaros', 'Lachaqui', 'San Buenaventura', 'Santa Rosa de Quives'],
    'Cañete': ['San Vicente de Cañete', 'Asia', 'Calango', 'Cerro Azul', 'Chilca', 'Coayllo', 'Imperial', 'Lunahuaná', 'Mala', 'Nuevo Imperial', 'Pacarán', 'Quilmaná', 'San Antonio', 'San Luis', 'Santa Cruz de Flores', 'Zúñiga'],
    'Huaral': ['Huaral', 'Atavillos Alto', 'Atavillos Bajo', 'Aucallama', 'Chancay', 'Ihuarí', 'Lampián', 'Pacaraos', 'San Miguel de Acos', 'Santa Cruz de Andamarca', 'Sumbilca', 'Veintisiete de Noviembre'],
    'Huarochirí': ['Matucana', 'Antioquia', 'Callahuanca', 'Carampoma', 'Chicla', 'Cuenca', 'Huachupampa', 'Huanza', 'Huarochirí', 'Lahuaytambo', 'Langa', 'Laraos', 'Mariatana', 'Ricardo Palma', 'San Andrés de Tupicocha', 'San Antonio', 'San Bartolomé', 'San Damián', 'San Juan de Iris', 'San Juan de Tantaranche', 'San Lorenzo de Quinti', 'San Mateo', 'San Mateo de Otao', 'San Pedro de Casta', 'San Pedro de Huancayre', 'Sangallaya', 'Santa Cruz de Cocachacra', 'Santa Eulalia', 'Santiago de Anchucaya', 'Santiago de Tuna', 'Santo Domingo de Los Olleros', 'Surco'],
    'Huaura': ['Huacho', 'Ambar', 'Caleta de Carquín', 'Checras', 'Hualmay', 'Huaura', 'Leoncio Prado', 'Paccho', 'Santa Leonor', 'Santa María', 'Sayan', 'Végueta'],
    'Oyón': ['Oyón', 'Andajes', 'Caujul', 'Cochamarca', 'Naván', 'Pachangara'],
    'Yauyos': ['Yauyos', 'Alis', 'Allauca', 'Ayaviri', 'Azángaro', 'Cacra', 'Carania', 'Catahuasi', 'Chocos', 'Cochas', 'Colonia', 'Hongos', 'Huampara', 'Huancaya', 'Huangáscar', 'Huantán', 'Huañec', 'Laraos', 'Lincha', 'Madeán', 'Miraflores', 'Omas', 'Putinza', 'Quinches', 'Quinocay', 'San Joaquín', 'San Pedro de Pilas', 'Tanta', 'Tauripampa', 'Tomas', 'Tupe', 'Viñac', 'Vitis']
  },

  'Lima (Metropolitana)': {
    'Lima': ['Lima', 'Ancón', 'Ate', 'Barranco', 'Breña', 'Carabayllo', 'Chaclacayo', 'Chorrillos', 'Cieneguilla', 'Comas', 'El Agustino', 'Independencia', 'Jesús María', 'La Molina', 'La Victoria', 'Lince', 'Los Olivos', 'Lurigancho-Chosica', 'Lurín', 'Magdalena del Mar', 'Pueblo Libre', 'Miraflores', 'Pachacamac', 'Pucusana', 'Puente Piedra', 'Punta Hermosa', 'Punta Negra', 'Rímac', 'San Bartolo', 'San Borja', 'San Isidro', 'San Juan de Lurigancho', 'San Juan de Miraflores', 'San Luis', 'San Martín de Porres', 'San Miguel', 'Santa Anita', 'Santa María del Mar', 'Santa Rosa', 'Santiago de Surco', 'Surquillo', 'Villa El Salvador', 'Villa María del Triunfo']
  },

  'Loreto': {
    'Maynas': ['Iquitos', 'Alto Nanay', 'Fernando Lores', 'Indiana', 'Las Amazonas', 'Mazán', 'Napo', 'Punchana', 'Putumayo', 'Torres Causana', 'Belén', 'San Juan Bautista'],
    'Alto Amazonas': ['Yurimaguas', 'Balsapuerto', 'Jeberos', 'Lagunas', 'Santa Cruz', 'Teniente César López Rojas'],
    'Loreto': ['Nauta', 'Parinari', 'Tigre', 'Trompeteros', 'Urarinas'],
    'Mariscal Ramón Castilla': ['Caballococha', 'Pebas', 'Ramón Castilla', 'San Pablo'],
    'Requena': ['Requena', 'Alto Tapiche', 'Capelo', 'Emilio San Martín', 'Maquia', 'Puinahua', 'Saquena', 'Soplin', 'Tapiche', 'Jenaro Herrera', 'Yaquerana'],
    'Ucayali': ['Contamana', 'Inahuaya', 'Padre Márquez', 'Pampa Hermosa', 'Sarayacu', 'Vargas Guerra'],
    'Datem del Marañón': ['Barranca', 'Cahuapanas', 'Manseriche', 'Morona', 'Pastaza', 'Andoas'],
    'Putumayo': ['Putumayo', 'Rosa Panduro', 'Teniente Manuel Clavero', 'Yaguas']
  },

  'Madre de Dios': {
    'Tambopata': ['Tambopata', 'Inambari', 'Las Piedras', 'Laberinto'],
    'Manu': ['Manu', 'Fitzcarrald', 'Huepetuhe', 'Madre de Dios'],
    'Tahuamanu': ['Iñapari', 'Iberia', 'Tahuamanu']
  },

  'Moquegua': {
    'Mariscal Nieto': ['Moquegua', 'Carumas', 'Cuchumbaya', 'Samegua', 'San Cristóbal', 'Torata'],
    'General Sánchez Cerro': ['Omate', 'Chojata', 'Coalaque', 'Ichuña', 'La Capilla', 'Lloque', 'Matalaque', 'Puquina', 'Quinistaquillas', 'Ubinas', 'Yunga'],
    'Ilo': ['Ilo', 'El Algarrobal', 'Pacocha']
  },

  'Pasco': {
    'Pasco': ['Chaupimarca', 'Huachón', 'Huariaca', 'Huayllay', 'Ninacaca', 'Pallanchacra', 'Paucartambo', 'San Francisco de Asís de Yarusyacán', 'Simon Bolívar', 'Ticlacayán', 'Tinyahuarco', 'Vicco', 'Yanacancha'],
    'Daniel Alcides Carrión': ['Yanahuanca', 'Chacayán', 'Goyllarisquizga', 'Paucar', 'San Pedro de Pillao', 'Santa Ana de Tusi', 'Tapuc', 'Vilcabamba'],
    'Oxapampa': ['Oxapampa', 'Chontabamba', 'Huancabamba', 'Cochran', 'Comunidad Nativa El 10', 'Palcazu', 'Pozuzo', 'Puerto Bermúdez', 'Villa Rica', 'Yanesha']
  },

  'Piura': {
    'Piura': ['Piura', 'Castilla', 'Catacaos', 'Cura Mori', 'El Tallán', 'La Arena', 'La Unión', 'Las Lomas', 'Tambo Grande', 'Veintiséis de Octubre'],
    'Ayabaca': ['Ayabaca', 'Frias', 'Jililí', 'Lagunas', 'Montero', 'Pacaipampa', 'Paimas', 'Sapillica', 'Sicchez', 'Suyo'],
    'Huancabamba': ['Huancabamba', 'Canchaque', 'El Carmen de la Frontera', 'Huarmaca', 'Lalaquiz', 'San Miguel de El Faique', 'Sondor', 'Sondorillo'],
    'Morropón': ['Chulucanas', 'Buenos Aires', 'Chalaco', 'La Matanza', 'Morropón', 'Salitral', 'San Juan de Bigote', 'Santa Catalina de Mossa', 'Santo Domingo', 'Yamango'],
    'Paita': ['Paita', 'Amotape', 'Arenal', 'Colán', 'La Huaca', 'Tamarindo', 'Vichayal'],
    'Sullana': ['Sullana', 'Bellavista', 'Ignacio Escudero', 'Lancones', 'Marcavelica', 'Miguel Checa', 'Querecotillo', 'Salitral'],
    'Talara': ['Pariñas', 'El Alto', 'La Brea', 'Lobitos', 'Los Órganos', 'Máncora'],
    'Sechura': ['Sechura', 'Bellavista de La Unión', 'Bernal', 'Cristo Nos Valga', 'Vice', 'Rinconada Llicuar']
  },

  'Puno': {
    'Puno': ['Puno', 'Acora', 'Amantaní', 'Atuncolla', 'Capachica', 'Chucuito', 'Coata', 'Huata', 'Mañazo', 'Paucarcolla', 'Pichacani', 'Plateria', 'San Antonio', 'Tiquillaca', 'Vilque'],
    'Azángaro': ['Azángaro', 'Achaya', 'Arapa', 'Asillo', 'Caminaca', 'Chupa', 'José Domingo Choquehuanca', 'Muñani', 'Potoni', 'Saman', 'San Antón', 'San José', 'San Juan de Salinas', 'Santiago de Pupuja', 'Tirapata'],
    'Carabaya': ['Macusani', 'Ajoyani', 'Ayapata', 'Coasa', 'Corani', 'Crucero', 'Ituata', 'Ollachea', 'San Gabán', 'Usicayos'],
    'Chucuito': ['Juli', 'Desaguadero', 'Huacullani', 'Kelluyo', 'Pisacoma', 'Pomata', 'Zepita'],
    'El Collao': ['Ilave', 'Capazo', 'Pilcuyo', 'Santa Rosa', 'Conduriri'],
    'Huancané': ['Huancané', 'Cojata', 'Huatasani', 'Inchupalla', 'Pusi', 'Rosaspata', 'Taraco', 'Vilque Chico'],
    'Lampa': ['Lampa', 'Cabanilla', 'Calapuja', 'Nicasio', 'Ocuviri', 'Palca', 'Paratía', 'Pucará', 'Santa Lucía', 'Vilavila'],
    'Melgar': ['Ayaviri', 'Antauta', 'Cupi', 'Llalli', 'Macari', 'Nuñoa', 'Orurillo', 'Santa Rosa', 'Umachiri'],
    'Moho': ['Moho', 'Conima', 'Huayrapata', 'Tilali'],
    'San Antonio de Putina': ['Putina', 'Ananea', 'Pedro Vilca Apaza', 'Quilcapuncu', 'Sina'],
    'San Román': ['Juliaca', 'Cabana', 'Cabanillas', 'Caracoto'],
    'Sandia': ['Sandia', 'Cuyocuyo', 'Limbani', 'Patambuco', 'Phara', 'Quiaca', 'San Juan del Oro', 'Yanahuaya', 'Alto Inambari', 'San Pedro de Putina Punco'],
    'Yunguyo': ['Yunguyo', 'Anapia', 'Copani', 'Cuturapi', 'Ollaraya', 'Tinicachi', 'Unicachi']
  },

  'San Martín': {
    'Moyobamba': ['Moyobamba', 'Calzada', 'Habana', 'Jepelacio', 'Soritor', 'Yantaló'],
    'Bellavista': ['Bellavista', 'Alto Biavo', 'Bajo Biavo', 'Huallaga', 'San Pablo', 'San Rafael'],
    'El Dorado': ['San José de Sisa', 'Agua Blanca', 'San Martín', 'Santa Rosa', 'Shatoja'],
    'Huallaga': ['Saposoa', 'Alto Saposoa', 'El Eslabón', 'Piscoyacu', 'Sacanche', 'Tingo de Saposoa'],
    'Lamas': ['Lamas', 'Alonso de Alvarado', 'Barranquita', 'Caynarachi', 'Cumba', 'Pinto Recodo', 'Rumisapa', 'San Roque de Cumbaza', 'Shanao', 'Tabalosos', 'Zapatero'],
    'Mariscal Cáceres': ['Juanjuí', 'Campanilla', 'Huicungo', 'Pachiza', 'Pajarillo'],
    'Picota': ['Picota', 'Buenos Aires', 'Caspisapa', 'Pilluana', 'Pucacaca', 'San Cristóbal', 'San Hilarión', 'Shamboyacu', 'Tingo de Ponasa', 'Tres Unidos'],
    'Rioja': ['Rioja', 'Awajún', 'Elías Soplín Vargas', 'Nueva Cajamarca', 'Pardo Miguel', 'Posic', 'San Fernando', 'Yorongos', 'Yuracyacu'],
    'San Martín': ['Tarapoto', 'Alberto Leveau', 'Cacatachi', 'Chazuta', 'Chipurana', 'El Porvenir', 'Huimbayoc', 'Juan Guerra', 'La Banda de Shilcayo', 'Morales', 'Papaplaya', 'San Antonio', 'Sauce', 'Shapaja'],
    'Tocache': ['Tocache', 'Nuevo Progreso', 'Polvora', 'Shunte', 'Uchiza']
  },

  'Tacna': {
    'Tacna': ['Tacna', 'Alto de la Alianza', 'Calana', 'Ciudad Nueva', 'Inclán', 'Pachía', 'Palca', 'Pocollay', 'Sama'],
    'Candarave': ['Candarave', 'Cairani', 'Camilaca', 'Curibaya', 'Huanuara', 'Quilahuani'],
    'Jorge Basadre': ['Locumba', 'Ilabaya', 'Ite'],
    'Tarata': ['Tarata', 'Héroes Albarracín', 'Estique', 'Estique-Pampa', 'Sitajara', 'Susapaya', 'Tarucachi', 'Ticaco']
  },

  'Tumbes': {
    'Tumbes': ['Tumbes', 'Corrales', 'La Cruz', 'Pampas de Hospital', 'San Jacinto', 'San Juan de la Virgen'],
    'Contralmirante Villar': ['Zorritos', 'Casitas', 'Canoas de Punta Sal'],
    'Zarumilla': ['Zarumilla', 'Aguas Verdes', 'Matapalo', 'Papayal']
  },

  'Ucayali': {
    'Coronel Portillo': ['Pucallpa', 'Calleria', 'Campoverde', 'Iparia', 'Masisea', 'Yarinacocha', 'Nueva Requena', 'Manantay'],
    'Atalaya': ['Raymondi', 'Sepahua', 'Tahuania', 'Yurua'],
    'Padre Abad': ['Padre Abad', 'Irazola', 'Curimana', 'Neshuya', 'Alexander Von Humboldt'],
    'Purús': ['Purus']
  },
};

window.data_peru = data; // para que se pueda acceder a los datos desde cualquier parte del proyecto

document.addEventListener("DOMContentLoaded", function() {
  loadDepartamentos();
  loadDepartamentosCart();
  setTimeout(function() {
    normalInfo();
  }, 1000);

  // Eventos para los selectores del header
  document.getElementById('header-departamentos').addEventListener('change', function() {
      // Limpiar valores de provincia y distrito cuando cambia departamento
      localStorage.setItem('selectedProvincia', '');
      localStorage.setItem('selectedDistrito', '');
      loadProvincias(this.value);
      loadDistritos();  // para limpiar los distritos cuando se cambia el departamento
      syncToCart();
      setTimeout(function() {
        normalInfo();
      }, 1000);
  });

  document.getElementById('header-provincias').addEventListener('change', function() {
      // Limpiar valor de distrito cuando cambia provincia
      localStorage.setItem('selectedDistrito', '');
      loadDistritos(this.value);
      syncToCart();
      setTimeout(function() {
        normalInfo();
      }, 1000);
  });

  document.getElementById('header-all-distritos').addEventListener('change', function() {
      syncToCart();
      setTimeout(function() {
        normalInfo();
      }, 1000);
  });

  // Eventos para los selectores del carrito
  if(document.getElementById('cart-departamentos') !== null) {
    document.getElementById('cart-departamentos').addEventListener('change', function() {
        loadProvinciasCart(this.value);
        loadDistritosCart();  // para limpiar los distritos cuando se cambia el departamento
        syncToHeader();
    });
  }

  if(document.getElementById('cart-provincias') !== null) {
    document.getElementById('cart-provincias').addEventListener('change', function() {
        loadDistritosCart(this.value);
        syncToHeader();
    });
  }

  if(document.getElementById('cart-all-distritos') !== null) {
    document.getElementById('cart-all-distritos').addEventListener('change', function() {
        syncToHeader();
    });
  }
});

function loadDepartamentos() {
  const departamentosDropdown = document.getElementById('header-departamentos');
  departamentosDropdown.innerHTML = "<option value=''>Seleccione un Departamento</option>";
  for (let departamento in data) {
      let option = document.createElement('option');
      option.value = departamento;
      option.innerText = departamento;
      departamentosDropdown.appendChild(option);
  }
}

function loadProvincias(departamento) {
  const provinciasDropdown = document.getElementById('header-provincias');
  provinciasDropdown.innerHTML = "<option value=''>Seleccione una Provincia</option>";

  if (data[departamento]) {
      for (let provincia in data[departamento]) {
          let option = document.createElement('option');
          option.value = provincia;
          option.innerText = provincia; 
          provinciasDropdown.appendChild(option);
      }
  }
}

function loadDistritos(provincia) {
  const departamentosDropdown = document.getElementById('header-departamentos');
  const distritosDropdown = document.getElementById('header-all-distritos');
  distritosDropdown.innerHTML = "<option value=''>Seleccione un Distrito</option>";

  const selectedDepartamento = departamentosDropdown.value;
  if (data[selectedDepartamento] && data[selectedDepartamento][provincia]) {
      data[selectedDepartamento][provincia].forEach(distrito => {
          let option = document.createElement('option');
          option.value = distrito;
          option.innerText = distrito;
          distritosDropdown.appendChild(option);
      });
  }
}

function loadDepartamentosCart() {
  const departamentosDropdownCart = document.getElementById('cart-departamentos');
  if(departamentosDropdownCart !== null){
    departamentosDropdownCart.innerHTML = "<option value=''>Seleccione un Departamento</option>";
    for (let departamento in data) {
      let option = document.createElement('option');
      option.value = departamento;
      option.innerText = departamento;
      departamentosDropdownCart.appendChild(option);
    }
  }


}

function loadProvinciasCart(departamento) {
  const provinciasDropdownCart = document.getElementById('cart-provincias');
  provinciasDropdownCart.innerHTML = "<option value=''>Seleccione una Provincia</option>";

  if (data[departamento]) {
      for (let provincia in data[departamento]) {
          let option = document.createElement('option');
          option.value = provincia;
          option.innerText = provincia;
          provinciasDropdownCart.appendChild(option);
      }
  }
}

function loadDistritosCart(provincia) {
  const departamentosDropdownCart = document.getElementById('cart-departamentos');
  const distritosDropdownCart = document.getElementById('cart-all-distritos');
  distritosDropdownCart.innerHTML = "<option value=''>Seleccione un Distrito</option>";

  const selectedDepartamento = departamentosDropdownCart.value;
  if (data[selectedDepartamento] && data[selectedDepartamento][provincia]) {
      data[selectedDepartamento][provincia].forEach(distrito => {
          let option = document.createElement('option');
          option.value = distrito;
          option.innerText = distrito;
          distritosDropdownCart.appendChild(option);
      });
  }
}

// Sincroniza los cambios del header al carrito
function syncToCart() {
  const headerDepartamento = document.getElementById('header-departamentos')?.value || '';
  const headerProvincia = document.getElementById('header-provincias')?.value || '';
  const headerDistrito = document.getElementById('header-all-distritos')?.value || '';

  // Get cart elements with null checks
  const cartDepartamentos = document.getElementById('cart-departamentos');
  const cartProvincias = document.getElementById('cart-provincias');
  const cartDistritos = document.getElementById('cart-all-distritos');

  // Only proceed if cart elements exist
  if (cartDepartamentos && headerDepartamento) {
    cartDepartamentos.value = headerDepartamento;
    loadProvinciasCart(headerDepartamento);
  }

  if (cartProvincias && headerProvincia) {
    cartProvincias.value = headerProvincia;
    loadDistritosCart(headerProvincia);
  }

  if (cartDistritos && headerDistrito) {
    cartDistritos.value = headerDistrito;
  }

  // Only call checkCheckoutButton if it exists
  if (typeof checkCheckoutButton === 'function') {
    checkCheckoutButton();
  }
}

// Sincroniza los cambios del carrito al header y guarda en localStorage
function syncToHeader() {
  const cartDepartamento = document.getElementById('cart-departamentos').value;
  const cartProvincia = document.getElementById('cart-provincias').value;
  const cartDistrito = document.getElementById('cart-all-distritos').value;

  // Sincronizar con el header
  if (cartDepartamento) {
      document.getElementById('header-departamentos').value = cartDepartamento;
      loadProvincias(cartDepartamento);
  }

  if (cartProvincia) {
      document.getElementById('header-provincias').value = cartProvincia;
      loadDistritos(cartProvincia);
  }

  if (cartDistrito) {
      document.getElementById('header-all-distritos').value = cartDistrito;
  }

  // Guardar en localStorage
  localStorage.setItem('selectedDepartamento', cartDepartamento);
  localStorage.setItem('selectedProvincia', cartProvincia);
  localStorage.setItem('selectedDistrito', cartDistrito);

  // Actualizar el texto del elemento con la clase "open-regiones"
  const openRegionesElement = document.querySelector('.open-regiones');
  if (openRegionesElement && cartDistrito) {
      openRegionesElement.textContent = cartDistrito;
  }
}